import mdhtml from '../content/text1.md';
import { promptEvents, classDates, moduleEvents, problemSetsAssignedEvents, problemSetsDueEvents, breakDayEvents, dialogueEvents, examEvents, cancelledEvents } from '../content/calendarinfo'
import { Calendar } from '@fullcalendar/core';
import dayGridPlugin from '@fullcalendar/daygrid';
import interactionPlugin from '@fullcalendar/interaction';


document.querySelector(".bodytext").innerHTML = mdhtml;

const monthNames = ["January", "February", "March", "April", "May", "June",
      "July", "August", "September", "October", "November", "December"
    ];

const formatDate = x => {
    const date = new Date(x+'T00:00:00');
    const day = date.getDate();
    const month = monthNames[date.getMonth()];
    return month.slice(0,3)+" "+day;
}

const moduleStartDates = moduleEvents.filter(x=>x.firstinmodule)


const readingsTableLines = moduleEvents.reduce((acc, curr, i) => (acc+`
            <tr class="${i%2!==0 ? "pure-table-odd" : ""}">
                <td id="reading-${curr.start}">${formatDate(curr.start)}</td>
                <td>${curr.firstinmodule ? curr.title : ""}
                </td>
                <td><ul>${curr.readings.map(x=>`<li>${x}</li>`).join('')}</ul></td>
                <td>${curr.slides ? `<button class="slidesbutton" onclick="window.location.href='https://aislides.netlify.app/slides/${curr.slides}';">slides</button>` : ``}</td>
            </tr>`
            ), "")


document.querySelector(".readings").innerHTML = `
    <thead>
        <tr>
            <th>Date</th>
            <th>Module</th>
            <th style="min-width:600px">Readings</th>
            <th>Slides</th>
        </tr>
    </thead>
    <tbody>
        ${readingsTableLines}
    </tbody>
`



const calendarEl = document.getElementById('calendar');

const calendar = new Calendar(calendarEl, {
	    plugins: [ dayGridPlugin, interactionPlugin],
		eventSources: [{events: moduleEvents, display: 'background', backgroundColor: "#444944"},
						{events: problemSetsAssignedEvents, display: 'list-item', color: "#00bdbd", textColor: "#00bdbd"},
                        {events: problemSetsDueEvents, display: 'list-item', color: "#00bdbd", textColor: "#00bdbd"},
                        {events: promptEvents, display: 'list-item', color: "#00bdbd", textColor: "#00bdbd"},
						{events: breakDayEvents, display: 'background', backgroundColor: '#444477'},
                        {events: dialogueEvents, display: 'list-item', color: "#00bdbd", textColor: "#00bdbd"},
						{events: examEvents, display: 'background', backgroundColor: '#844'},
                        {events: cancelledEvents, display: 'background', backgroundColor: '#844'}
						],
        dateClick: function(info) {
            const clickedDate = info.dateStr.slice(0,10);
            if (classDates.includes(clickedDate)) {
                document.getElementById("reading-"+clickedDate).scrollIntoView();
            }
        }
});

calendar.render();

var styleEl = document.createElement('style'), styleSheet;
            document.head.appendChild(styleEl);
            styleSheet = styleEl.sheet;
            styleSheet.insertRule(".fc-daygrid-dot-event {white-space: normal; color: #00bdbd}", 0);
            styleSheet.insertRule(".fc .fc-bg-event {opacity: 0.5}", 0);
            styleSheet.insertRule(".fc-event-time {opacity: 0}", 0);


/* glitchy collapse animations */

function toggleModule(num) {
    let description = document.querySelectorAll(".deets")[num];
    if (!description.classList.contains("deetshow")) {
        description.classList.add("deetsshow");
        description.classList.add("glitch");
    }
}


setTimeout(function() {
    const detailsButtons = document.querySelectorAll(".detailsbutton");
    detailsButtons.forEach((node, i)=>{node.onclick = () => toggleModule(i)});
}, 100);




function randomSkew() {
    return (Math.floor(Math.random()*120)-60)+"deg";
}

function randomOffset() {
    return randomChoice("0.2em","0.1em","0","-0.1em","-0.2em");
}

function randomizeGlitching() {
    let elem = document.getElementById("glitchy");
    elem.style.setProperty('--skew-1', randomSkew());
    elem.style.setProperty('--skew-2', randomSkew());
    elem.style.setProperty('--offset1', randomOffset());
    elem.style.setProperty('--offset2', randomOffset());
    elem.style.setProperty('--offset3', randomOffset());
    elem.style.setProperty('--offset4', randomOffset());
    elem.style.setProperty('--offset5', randomOffset());
    elem.style.setProperty('--offset6', randomOffset());
    elem.style.setProperty('--offset7', randomOffset());
    elem.style.setProperty('--offset8', randomOffset());
}



